import React from "react";
import "./Muhammadabad.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Mau = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Top Aluminium Window Dealers in Mau | Trusted Sliding Window & Fabrication Services</title>
        <meta
          name="description"
          content="Find top aluminium window dealers in Mau. Skilled local fabricators provide sliding windows, doors, partitions, and custom aluminium solutions for homes, shops, and commercial spaces."
        />
        <meta
          name="keywords"
          content="Aluminium Windows Mau, Aluminium Doors, Sliding Windows, Aluminium Fabricators, Custom Aluminium Work, Window Installation, Aluminium Window Dealers Mau"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Top Aluminium Window Dealers in Mau" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, and custom solutions for homes and commercial properties in Mau."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Top Aluminium Window Dealers in Mau" />
        <meta
          name="twitter:description"
          content="Skilled local aluminium fabricators providing sliding windows, doors, partitions, and custom aluminium solutions for homes and shops in Mau."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Top Aluminium Window Dealers in Mau</h1>
            <p>
              Top aluminium window dealers in Mau play an important role in today’s growing construction and renovation market. With rapid development in residential houses, shops, showrooms, and commercial buildings across Mau district, the demand for strong, stylish, and low-maintenance windows has increased significantly. Aluminium windows are preferred for their durability, modern design, and long-term value.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-windows-mau"
          />
        </div>
      </section>

      {/* WHY ALUMINIUM WINDOWS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Windows Are a Smart Choice in Mau</h2>
          <p>
            When people search for the best aluminium window dealers in Mau, they usually look for quality workmanship, fair pricing, and reliable installation. Local aluminium fabricators specialize in sliding windows, fixed windows, casement windows, and custom designs. Their knowledge of the local climate and building styles ensures windows that last longer and perform efficiently.
          </p>
          <p>
            Sliding aluminium windows are especially popular because they save space and provide smooth operation. They are ideal for bedrooms, kitchens, offices, and shops. Many dealers also offer mosquito mesh, safety grills, tinted glass, and powder-coated frames to match modern interior and exterior styles.
          </p>
        </div>
      </section>

      {/* TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="trusted-fabricators-mau"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators in Mau</h2>
          <p>
            Customers often prefer local workshops over big brands because local dealers provide customized sizes, faster installation, and better after-sales support. Experienced fabricators handle the entire process from measurement to final installation efficiently and guide customers on aluminium grade, glass thickness, and hardware to ensure safety and durability.
          </p>
          <p>
            Local fabricators also serve nearby towns and villages, offering flexible schedules, transparent pricing, and quick communication.
          </p>
        </div>
      </section>

      {/* SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are one of the most requested services in Mau. They save space, allow natural light, and give a modern finish to any room. Kitchens, bedrooms, balconies, and bathrooms benefit greatly from sliding windows.
            </p>
            <p>
              Shops and commercial spaces often prefer aluminium sliding doors with glass panels for a welcoming, open look while maintaining safety. Aluminium frames support larger glass panels without compromising strength, making them ideal for offices and showrooms.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and Glass Work in Mau</h2>
          <p>
            Every building has different requirements, and custom aluminium fabrication ensures perfect fitting and lasting durability. Fabricators in Mau offer custom designs for window grills, safety grills, partitions, ACP sheet work, and glass fittings.
          </p>
          <p>
            They also provide repair and replacement services for damaged glass, locks, and sliding systems, making them reliable for long-term maintenance.
          </p>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas-mau"
          />
          <div className="dp-box">
            <h2>Serving Mau and Surrounding Areas</h2>
            <p>
              Aluminium window services are widely available throughout Mau and nearby towns, making site visits, measurements, and installations convenient. Local coverage helps homeowners, builders, and shop owners complete projects on time and within budget.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="aluminium-content">
        <div className="container">

          <h1>Choosing Aluminium Window Works in Mau</h1>
          <p>
            Mau has rapidly developed into a hub for aluminium, UPVC, and steel fabrication services. With growing residential and commercial construction, skilled aluminium window fabricators are in high demand. They offer sliding windows, custom designs, and modern fittings for homes, shops, and offices.
          </p>

          <h2>Aluminium, UPVC & Steel Works in Mau</h2>
          <p>
            From aluminium windows and UPVC systems to rolling shutters and steel fabrication, local fabricators in Mau provide high-quality, customized solutions for residential and commercial projects.
          </p>

          <h2>Top Aluminium Window Grill Dealers in Mau</h2>
          <p>
            Aluminium window grills provide strength, security, and a sleek look. Leading dealers in Mau offer rust-free, low-maintenance, and stylish designs suitable for homes, shops, and commercial spaces.
          </p>

          <h2>Top UPVC Window Dealers in Mau</h2>
          <p>
            UPVC windows are popular for their sound insulation, thermal efficiency, and durability. Trusted UPVC window dealers in Mau supply sliding, casement, and fixed windows to withstand noise and weather conditions.
          </p>

          <h2>Rolling Shutter Manufacturers in Mau</h2>
          <p>
            Rolling shutters protect shops, warehouses, and commercial spaces. Reliable manufacturers in Mau offer manual and motorized shutters made from heavy-duty steel and aluminium.
          </p>

          <h2>Aluminium & Steel Fabrication in Mau</h2>
          <p>
            Local fabricators specialize in custom work such as aluminium sliding windows and doors, steel gates, railings, glass partitions, and structural supports.
          </p>

          <h2>Top Hardware Dealers in Mau</h2>
          <p>
            Hardware dealers supply fittings and accessories needed for aluminium, UPVC, and steel works, ensuring smooth operation, safety, and long-lasting performance.
          </p>

        </div>
      </section>

      {/* CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default Mau;
